import * as React from 'react';
import { useOffset } from '../context/chartLayoutContext';
export function ClipPath(_ref) {
  var {
    clipPathId
  } = _ref;
  var offset = useOffset();
  if (offset == null) {
    return null;
  }
  var {
    left,
    top,
    height,
    width
  } = offset;
  return /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    x: left,
    y: top,
    height: height,
    width: width
  })));
}